import { useState } from 'react'
import axios from 'axios'

export default function SupportContactForm() {
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: ''
  })
  const [showConfirm, setShowConfirm] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  // Gestion des changements de formulaire
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // Soumettre le formulaire
  const handleSubmit = (e) => {
    e.preventDefault()
    setShowConfirm(true) // Affiche la boîte de confirmation
  }

  // Confirmer l'envoi et envoyer l'email
  const confirmSend = async () => {
    setShowConfirm(false) // Ferme la boîte de confirmation

    try {
      await axios.post("http://localhost:5000/send-email", formData)
      
      setTimeout(() => {
        setShowSuccess(true) // Affiche la boîte de succès après 2 sec
      }, 2000)

      // Réinitialiser le formulaire après l'envoi
      setFormData({ email: '', subject: '', message: '' })
      
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email :", error)
    }
  }

  return (
    <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          Besoin d’aide ? Contactez-nous !
        </h2>
        <p className="mt-2 text-lg text-gray-600">
          Une question ou un problème ? L’équipe support de <span className="font-semibold text-[#21295c]">NANTHIAT</span> est à votre disposition.
        </p>
      </div>

      {/* Formulaire */}
      <form onSubmit={handleSubmit} className="mx-auto mt-16 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-y-6">
          {/* Email */}
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-gray-900">
              Email
            </label>
            <div className="mt-2.5">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="block w-full rounded-md border border-gray-300 bg-white px-3.5 py-2 text-gray-900 shadow-sm focus:ring-[#ffd166] focus:border-[#ffd166]"
              />
            </div>
          </div>

          {/* Sujet */}
          <div>
            <label htmlFor="subject" className="block text-sm font-semibold text-gray-900">
              Sujet de votre demande
            </label>
            <div className="mt-2.5">
              <input
                id="subject"
                name="subject"
                type="text"
                required
                value={formData.subject}
                onChange={handleChange}
                className="block w-full rounded-md border border-gray-300 bg-white px-3.5 py-2 text-gray-900 shadow-sm focus:ring-[#ffd166] focus:border-[#ffd166]"
              />
            </div>
          </div>

          {/* Message */}
          <div>
            <label htmlFor="message" className="block text-sm font-semibold text-gray-900">
              Message
            </label>
            <div className="mt-2.5">
              <textarea
                id="message"
                name="message"
                rows={4}
                required
                value={formData.message}
                onChange={handleChange}
                className="block w-full rounded-md border border-gray-300 bg-white px-3.5 py-2 text-gray-900 shadow-sm focus:ring-[#ffd166] focus:border-[#ffd166]"
              />
            </div>
          </div>
        </div>

        {/* Bouton d'envoi */}
        <div className="mt-10">
          <button type="submit" className="block w-full rounded-md bg-[#21295c] px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#141937]">
            Envoyer ma demande
          </button>
        </div>
      </form>

      {/* Boîte de confirmation */}
      {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm">
            <h3 className="text-lg font-semibold text-gray-800">Confirmer l'envoi</h3>
            <p className="text-gray-600 mt-2">Êtes-vous sûr de vouloir envoyer cette demande ?</p>
            <div className="mt-4 flex justify-center gap-4">
              <button onClick={() => setShowConfirm(false)} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100">Annuler</button>
              <button onClick={confirmSend} className="px-4 py-2 rounded-lg bg-[#21295c] text-white hover:bg-[#141937]">Confirmer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
